import { render } from "./AddNewVendor.vue?vue&type=template&id=1cd4f78a"
import script from "./AddNewVendor.vue?vue&type=script&lang=js"
export * from "./AddNewVendor.vue?vue&type=script&lang=js"

import "@/components/ManageCustomFields.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__